import Phaser from "phaser";
import { BootScene } from "./scenes/BootScene";
import { PreloadScene } from "./scenes/PreloadScene";
import { SplashScene } from "./scenes/splash/SplashScene";
import { BoardScene } from "./scenes/board/BoardScene";
import { inferIsLandscapeLayout, viewportLayout } from "./ui/Layout";
import { GameManager } from "./GameManager";

window.addEventListener("load", () => {
    const landscape = inferIsLandscapeLayout();
    const { width, height } = viewportLayout(landscape);
    new Phaser.Game({
        type: Phaser.AUTO,
        backgroundColor: "#2A0B20",
        scale: {
            mode: Phaser.Scale.FIT,
            autoCenter: landscape ? Phaser.Scale.CENTER_HORIZONTALLY : Phaser.Scale.CENTER_BOTH,
            parent: "content",
            width,
            height
        },
        scene: [BootScene, PreloadScene, SplashScene, BoardScene]
    });
    window.addEventListener("resize", GameManager.setGameSize);
});
